module.exports = __webpack_public_path__ + "static/media/welding.53ec1fcc.jpg";